"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "Introduction",
    class: "container"
};
const _hoisted_2 = { class: "intro" };
const _hoisted_3 = { class: "IntroductionTopContent" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_1.createElementVNode)("h1", { class: "IntroductionTitle" }, "Country Test", -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ (0, vue_1.createElementVNode)("p", { class: "IntroductionDurationWrapper" }, [
    /*#__PURE__*/ (0, vue_1.createElementVNode)("span", { class: "IntroductionDurationText" }, " The test takes only 1–2 minutes ")
], -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ (0, vue_1.createElementVNode)("p", { class: "IntroductionDescription" }, "Take the test and find out which study destinations match your profile.", -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ (0, vue_1.createElementVNode)("div", { class: "BannerWrapper" }, [
    /*#__PURE__*/ (0, vue_1.createElementVNode)("img", {
        src: "//monet-prtl-co.imgix.net/Shared/CountryTest/intro_background.svg",
        alt: "Country test banner"
    })
], -1 /* HOISTED */);
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                (0, vue_1.createElementVNode)("button", {
                    class: "DriverButton IntroductionCTA",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.startTest()))
                }, " Start the test ")
            ]),
            _hoisted_7
        ])
    ]));
}
exports.render = render;
